module.exports = __webpack_public_path__ + "img/company21.44ff3ffe.png";